import { Icon } from "./Icon.tsx";

/** "Visible on the map" state (ElementBrowser.tsx's per-category toggle). */
export function EyeIcon() {
  return (
    <Icon>
      <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </Icon>
  );
}
